import { navigate } from "gatsby";
import { ACTIVATION_BASE_URL } from "../constants";

export function getActivationPath(path: string) {
  return `${ACTIVATION_BASE_URL}${path.startsWith("/") ? "" : "/"}${path}${
    path.endsWith("/") ? "" : "/"
  }`;
}

export function navigateActivation(path: string) {
  navigate(getActivationPath(path));
}
